var _path, _mask, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseMyFrame5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.422 21.4865C33.1321 21.4865 31.9395 21.994 31.0699 22.8814C30.1016 23.8326 29.5432 25.2029 29.6807 26.6695C29.8998 29.2535 32.2253 31.0135 34.632 31.0135H36.781V31.92C36.781 34.893 34.35 37.324 31.377 37.324H11.287C8.31402 37.324 5.88303 34.893 5.88303 31.92V20.1425C5.88303 17.1695 8.31402 14.7385 11.287 14.7385H31.377C34.35 14.7385 36.781 17.1695 36.781 20.1425V21.4865H34.422Z",
    stroke: "white",
    strokeWidth: 2.352
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_7203_16878",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.70703 21.7178V13.7204C4.70703 11.6379 5.98453 9.78279 7.92703 9.04779L21.822 3.79779C23.992 2.97529 26.3195 4.58534 26.3195 6.91284V13.5628"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92703 9.04779L7.09573 6.8476L7.09468 6.848L7.92703 9.04779ZM21.822 3.79779L22.6533 5.99798L22.6556 5.99711L21.822 3.79779ZM7.05903 21.7178V13.7204H2.35503V21.7178H7.05903ZM7.05903 13.7204C7.05903 12.611 7.73587 11.6349 8.75939 11.2476L7.09468 6.848C4.23319 7.93072 2.35503 10.6647 2.35503 13.7204H7.05903ZM8.75834 11.248L22.6533 5.99798L20.9907 1.5976L7.09573 6.8476L8.75834 11.248ZM22.6556 5.99711C23.28 5.76045 23.9675 6.22383 23.9675 6.91284H28.6715C28.6715 2.94685 24.704 0.190132 20.9884 1.59847L22.6556 5.99711ZM23.9675 6.91284V13.5628H28.6715V6.91284H23.9675Z",
    fill: "white",
    mask: "url(#path-2-inside-1_7203_16878)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0238 26.4679L32.0239 26.4679L32.0226 26.4541C31.953 25.7236 32.2298 25.0364 32.7234 24.5546L32.7341 24.5441L32.7445 24.5334C33.169 24.0974 33.757 23.8391 34.4219 23.8391H38.0359C38.3911 23.8597 38.6359 24.1397 38.6359 24.448V28.0531C38.6359 28.3614 38.3911 28.6414 38.0359 28.662H34.6319C33.2608 28.662 32.1232 27.6601 32.0238 26.4679Z",
    stroke: "white",
    strokeWidth: 2.352
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.582 21H24.832",
    stroke: "white",
    strokeWidth: 3.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseMyFrame5);
export default __webpack_public_path__ + "static/media/use_my_frame5.76bb005c962a149703257a05959d88fc.svg";
export { ForwardRef as ReactComponent };